import type {ExplainerStep} from 'spreadsheet-import-wizard/finalize/Explainer';

export const MOLECULE_IMPORT_EXPLAINER_HEADER = 'After you click "Import"';

export const MOLECULE_IMPORT_EXPLAINER_STEPS: ReadonlyArray<ExplainerStep> = [
  {
    title: 'Spreadsheet validation',
    description: "We'll check that all data exists both in the spreadsheet and in Benchling",
  },
  {
    title: 'Entity creation',
    description:
      "We'll create each molecule in your upload as a new entity. We'll also automatically create the base molecule of any salts or solvents that reference a base molecule that doesn't exist in your organization.",
  },
  {
    title: 'Entity registration',
    description: "All successfully created entities will be registered into your organization's registry.",
  },
  {
    title: 'Error handling',
    description:
      "If molecules failed to import, you'll receive a notification and email containing a receipt of errors.",
  },
];
